define("ember-svg-jar/inlined/post-tagging", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M18 11V4h-7l-7 7 7 7 7-7zm-4.025-4.008a1.025 1.025 0 112.05 0 1.025 1.025 0 01-2.05 0zM11 20l8.415-8.415V6.992H24V24H8v-7l3 3z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});